'use client'

import React, { useEffect, useState } from 'react'

import '../../styles/components/_firefly_effect.scss'

interface FirefliesEffectProps {
  count?: number
  color?: string
  size?: number
  speed?: number
}

const FirefliesEffect: React.FC<FirefliesEffectProps> = ({
  count = 15,
  color = 'rgb(244, 115, 32)', // Default orange
  size = 0.4,
  speed = 1
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)

    // Apply speed as a CSS variable
    document.documentElement.style.setProperty('--firefly-speed-factor', speed.toString())
    // Apply color as a CSS variable
    document.documentElement.style.setProperty('--firefly-color', color)
    // Apply size as a CSS variable
    document.documentElement.style.setProperty('--firefly-size', `${size}vw`)
  }, [color, size, speed])

  // Generate the specified number of firefly elements
  const fireflies = Array.from({ length: count }, (_, i) => (
    <div key={`firefly-${i}`} className={`firefly firefly-${(i % 15) + 1}`}></div>
  ))

  return <div className={`fireflies-container ${isVisible ? 'visible' : ''}`}>{fireflies}</div>
}

export default FirefliesEffect
